import React, { useEffect, useState } from "react";
import leftArrow from "../../../assets/Images/left-arrow.png";
import rightArrow from "../../../assets/Images/right-arrow.png";
import Close from "../../../assets/Images/close.png";
import { DPR_API } from "../../../services/apiCalls/dprApiCalls";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";

export default function ManpowerList({ subId }) {
  const [open, setOpen] = useState(false);

  const onOpenModal = (data) => {
    setResourcesAll(data);
    setOpen(true);
  };
  const onCloseModal = () => setOpen(true);

  const [resources, setResources] = useState([]);
  const [resourcesAll, setResourcesAll] = useState([]);

  const getMapPowerBySub = async (id) => {
    const manP = await DPR_API.get_resourcebysubId(id);
    if (manP && manP.resources?.length) {
      setResources(manP.resources);
    }
  };

  useEffect(() => {
    getMapPowerBySub(subId);
  }, []);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const totalPages = Math.ceil(resources.length / rowsPerPage);

  const handleClick = (page) => {
    setCurrentPage(page);
  };

  const paginatedData = resources.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  return (
    <React.Fragment>
      <Modal open={open} onClose={onCloseModal} center>
        <div className="d-flex justify-content-between">
          <div>
            <span className="resorces">Resource Name</span>
          </div>
          <div>
            <img
              src={Close}
              width={20}
              onClick={() => {
                setOpen(false);
              }}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
        <hr />
        <div className="row">
          {resourcesAll?.map((val) => (
            <div>
              <span
                style={{
                  color: "rgba(0, 128, 198, 1)",
                  fontSize: 12,
                  fontWeight: 600,
                }}
              >
                {val}
              </span>
            </div>
          ))}
        </div>
      </Modal>

      <div className="table-container" style={{width:'100%'}}>
        <table className="custom-table">
          <thead className="table-header">
            <tr>
              <th>Sr No</th>
              <th>Role</th>
              <th>Role Type</th>
              <th>Resource Name</th>
              <th>No of Resources</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.map((row, index) => (
              <tr key={index}>
                <td>{index + 1 + (currentPage - 1) * 10}</td>
                <td
                  style={{
                    color: "rgb(102 104 106)",
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                >
                  {row.role}
                </td>
                <td
                  style={{
                    color: "rgb(102 104 106)",
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                >
                  {row.role_type}
                </td>
                <td
                  style={{
                    color: "rgb(102 104 106)",
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                >
                  {row?.Resource_name?.join()}
                  <span
                    className="view-all"
                    onClick={() => onOpenModal(row?.Resource_name)}
                  >
                    View All
                  </span>
                </td>
                <td
                  style={{
                    color: "rgb(102 104 106)",
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                >
                  <span className="no-of-resource">{row.no_of_resources}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div
          className="pagination"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10px 15px",
          }}
        >
          <div style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
            Showing{" "}
            {Math.min((currentPage - 1) * rowsPerPage + 1, resources.length)} to{" "}
            {Math.min(currentPage * rowsPerPage, resources.length)} of{" "}
            {resources.length} entries
          </div>

          <div
            className="pagination-buttons"
            style={{
              fontSize: "14px",
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
              gap: "5px",
            }}
          >
            {/* Left Arrow */}
            <button
              onClick={() => handleClick(Math.max(1, currentPage - 1))}
              disabled={currentPage === 1}
              style={{
                background: "none",
                border: "none",
                cursor: currentPage === 1 ? "not-allowed" : "pointer",
              }}
            >
              <img
                src={leftArrow} // Replace with your actual image path
                alt="Previous"
                height="11px"
                width="7px"
                style={{ opacity: currentPage === 1 ? 0.5 : 1 }}
              />
            </button>

            {/* Page Numbers */}
            {[...Array(totalPages)].map((_, i) => (
              <button
                key={i}
                onClick={() => handleClick(i + 1)}
                style={{
                  background: currentPage === i + 1 ? "#00B69B" : "transparent",
                  color: currentPage === i + 1 ? "#fff" : "#000",
                  border: "none",
                  borderRadius: "50%",
                  width: "30px",
                  height: "30px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
              >
                {i + 1}
              </button>
            ))}
            {/* Right Arrow */}
            <button
              onClick={() => handleClick(Math.min(totalPages, currentPage + 1))}
              disabled={currentPage === totalPages}
              style={{
                background: "none",
                border: "none",
                cursor: currentPage === totalPages ? "not-allowed" : "pointer",
              }}
            >
              <img
                src={rightArrow} // Replace with your actual image path
                alt="Next"
                height="11px"
                width="7px"
                style={{ opacity: currentPage === totalPages ? 0.5 : 1 }}
              />
            </button>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
